/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
import AuthPresenter from './AuthPresenter';
import AuthInterface from '../../infra/aggregates/AuthInterface';
import { userService } from '../../api/services/userService';
import { user_login, user_session } from '../../infra/aggregates/authSlice';
import { setAuthToken } from '../../infra/aggregates/authTokenSlice';
import { seEmpStatus } from '../../infra/aggregates/empStatusSlice';
import { clockInReducer } from '../../infra/aggregates/clockInSlice';
import { clockOutReducer } from '../../infra/aggregates/clockOutSlice';
import { setLoading } from '../../infra/aggregates/LoaderSlice';
import { useNavigate } from 'react-router-dom';

function AuthController() {
  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  async function login(usr: string, pass: string) {
    const payload = {
      username: usr,
      password: pass,
      application: 'E',
      locale: localStorage.getItem('emplang'),
    };
    await userService
      .login(payload)
      .then((response: any) => {
        if (response) {
          const user_obj: AuthInterface = {
            user_id: response?.user?.id,
            name: response?.employee?.first_name,
            username: response?.user?.username,
            profile_pic: response?.user?.profile_pic,
            email: response?.user?.email,
            status: response?.user?.status,
            company_id: response.company,
            designaion: response.designation?.name,
            department: response.department?.name,
            emp_id: response.employee?.id,
            department_id: response.department?.id,
            staff_id: response?.employee?.staff_id,
            hire_date: response?.employee?.emp_job_detail?.hire_date,
            currency: response?.currency?.name,
          };
          // temporary
          dispatch(user_session(response?.user_sessions_id));
          dispatch(user_login(user_obj));
          dispatch(setAuthToken(true));

          localStorage.setItem('isLoggedIn', 'true');

          dispatch(
            seEmpStatus(response?.employee?.is_active == 1 ? true : false),
          );
          if (response?.attendance_today?.length) {
            const clockInTime: any =
              response?.attendance_today[response?.attendance_today?.length - 1]
                .clock_in;

            const clockOutTime: any =
              response?.attendance_today[response?.attendance_today?.length - 1]
                .clock_out;

            dispatch(clockInReducer(clockInTime));
            dispatch(clockOutReducer(clockOutTime));
            dispatch(setLoading(false));
          }

          dispatch(setLoading(false));
          navigate({ pathname: '/dashboard' });
        } else {
          window.location.reload();
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));

        toast.error(
          err?.error?.data?.message
            ? err?.error?.data?.message
            : err?.error?.data
              ? err?.error?.data
              : 'Something went wrong!',
        );
      });
  }

  return (
    <>
      <Toaster />
      <AuthPresenter onSubmitLogin={login} isLoading={isLoading} />
    </>
  );
}
export default AuthController;
